import cx from 'classnames'
import { format, getMonth, getYear } from 'date-fns'
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker'

import { OldSelect, OldSelectOption } from '../../OldSelect'
import { getWeeksRange } from './WeeklyPicker'

function range(start: number, end: number) {
  return Array.from({ length: end - start + 1 }, (_, i) => i + start)
}

const years = range(2019, getYear(new Date()) + 1)

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export interface WeeklyPickerHeaderProps extends ReactDatePickerCustomHeaderProps {
  isRangeSelected: boolean
  rangeWeek: number
  startDate: Date | null | undefined
  endDate: Date | null | undefined
  onClickRangeDates: (value: Date[]) => void
  maxDate?: Date | null
}

export function WeeklyPickerHeader({
  changeYear,
  changeMonth,
  onClickRangeDates,
  isRangeSelected,
  rangeWeek,
  date,
  startDate,
  endDate,
}: WeeklyPickerHeaderProps) {
  const range = getWeeksRange(rangeWeek)

  const isLastSelected =
    isRangeSelected ||
    (startDate &&
      endDate &&
      startDate.getTime() === range[0].getTime() &&
      endDate.getTime() === range[1].getTime())

  return (
    <div className='flex flex-col items-start font-inter'>
      <div className={cx('absolute flex w-full flex-col items-start font-inter')}>
        <h2 className='mb-4 text-base font-semibold'>Select a Weekly Range</h2>
        <button
          className={cx(
            'mb-4 flex w-full items-center rounded-md p-3',
            isLastSelected
              ? 'bg-brand-blue-500 text-white  hover:bg-brand-blue-300'
              : 'hover:bg-brand-blue-50'
          )}
          aria-label={`Choose Last ${rangeWeek} weeks`}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            onClickRangeDates(range)
          }}
        >
          <p className={cx('text-sm ', isLastSelected ? 'font-semibold' : 'text-legacy-gray-operator')}>
            Last {rangeWeek} Weeks
          </p>
          <p
            className={cx(
              'flex-1 text-end text-sm font-normal',
              isLastSelected ? 'text-brand-blue-50' : 'text-[#6B7280]'
            )}
          >
            {getLabelForDaysPeriod(range)}
          </p>
        </button>

        <div className='mb-4 h-[1px] w-full bg-[#E5E7EB]' />
      </div>
      <div className='mb-2 flex w-full flex-col items-start pt-[114px]'>
        <div className='flex w-full justify-between gap-1'>
          <div className='flex-1'>
            <OldSelect
              value={months[getMonth(date)]}
              displayValue={(value) => value}
              onChange={(value) => changeMonth(months.indexOf(value))}
              buttonProps={{ 'aria-label': 'Select Month From List' }}
              buttonClassName='border-none font-semibold shadow-none !text-base flex justify-center'
              typeIcon='down'
            >
              {months.map((option) => (
                <OldSelectOption key={option} value={option} aria-label={`Choose ${option}`}>
                  {option}
                </OldSelectOption>
              ))}
            </OldSelect>
          </div>
          <div className='flex-1'>
            <OldSelect
              value={getYear(date)}
              displayValue={(value) => value.toString()}
              onChange={(value) => changeYear(value)}
              buttonProps={{ 'aria-label': 'Select Year From List' }}
              buttonClassName='border-none font-semibold shadow-none !text-base flex justify-center'
              typeIcon='down'
            >
              {years.map((option) => (
                <OldSelectOption key={option} value={option} aria-label={`Choose ${option}`}>
                  {option}
                </OldSelectOption>
              ))}
            </OldSelect>
          </div>
        </div>
      </div>
    </div>
  )
}

export const getLabelForDaysPeriod = (range: Date[]) => {
  const first = range[0]
  const last = range[1]
  const diffYears = getYear(last) - getYear(first)
  const formatPattern = diffYears > 0 ? 'dd MMM yyyy' : 'dd MMM'

  return `${format(first, formatPattern)} - ${format(last, formatPattern)}`
}
